import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Chip, useTheme } from '@mui/material';

import { CELL_STATE_COLORS } from '../../constants';

import type { CellState, RackStats } from '../../types';

type Props = {
  stats: RackStats;
};

const VISIBLE_STATES: { key: CellState; translationKey: string }[] = [
  { key: 'assigned', translationKey: 'rack.summaryAssigned' },
  { key: 'in-progress', translationKey: 'rack.summaryInProgress' },
  { key: 'complete', translationKey: 'rack.summaryComplete' },
  { key: 'failed', translationKey: 'rack.summaryFailed' },
  { key: 'skipped', translationKey: 'rack.summarySkipped' },
  { key: 'empty', translationKey: 'rack.summaryRemaining' }
];

const RackSummaryBar: React.FC<Props> = ({ stats }) => {
  const { t } = useTranslation('workOrderDetails');
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}
    >
      {VISIBLE_STATES.map(({ key, translationKey }) => {
        const count = stats[key];
        if (count === 0) return null;

        const colors = CELL_STATE_COLORS[key];

        return (
          <Chip
            key={key}
            size="small"
            label={`${t(translationKey)}: ${count}`}
            sx={{
              backgroundColor: isDarkMode
                ? colors.background.dark
                : colors.background.light,
              color: isDarkMode ? colors.text.dark : colors.text.light,
              border: `1px solid ${isDarkMode ? colors.border.dark : colors.border.light}`,
              fontWeight: 500,
              fontSize: '0.75rem'
            }}
          />
        );
      })}
    </Box>
  );
};

export default RackSummaryBar;
